import type { InferContractRouterOutputs } from '@orpc/contract'
import { useQuery } from '@tanstack/react-query'
import type { BaseContract } from 'pixai-contract/api/orpc'
import { getLocale } from 'src/stores/locale'
import { orpc } from './contract'
import { isModelFeatureEnabled, useModelFeatures } from './modelFeature'

export type InferenceProfile =
  InferContractRouterOutputs<BaseContract>['generationModel']['getInferenceProfiles']['profiles'][number]

export function useHasInferenceProfile(modelVersionId?: string) {
  const { data } = useModelFeatures(modelVersionId)
  return isModelFeatureEnabled(data?.features, 'inferenceProfile')
}

export function useInferenceProfiles(modelVersionId?: string, enabled = false) {
  const locale = getLocale()
  return useQuery({
    ...orpc.generationModel.getInferenceProfiles.queryOptions({
      input: { modelVersionId: modelVersionId ?? '' },
      context: { headers: { 'accept-language': locale } },
    }),
    enabled: enabled && !!modelVersionId,
  })
}

export function useInferenceProfileData(modelVersionId?: string) {
  const hasInferenceProfile = useHasInferenceProfile(modelVersionId)
  const { data, isLoading } = useInferenceProfiles(
    modelVersionId,
    hasInferenceProfile,
  )
  return { hasInferenceProfile, profiles: data?.profiles, isLoading }
}

export function profileHasStepRange(profile: InferenceProfile): boolean {
  return profile.minSteps != null && profile.maxSteps != null
}
